<template>
  <div>
    <nav id="nav_id" class="nav">
      <div class="inner">
        <div class="nav_top">
          <div class="inner">
            <h1 class="h1">
              <span>위생 교육</span>
            </h1>
          </div>
        </div>
        <div class="nav_btm">
          <div class="inner">
            <div class="line dep01">
              <div class="inner">
                <ul>
                  <li>
                    <router-link tag="button" to="/hygn/notice"
                      ><span>식품 위생 교육 안내</span></router-link
                    >
                  </li>
                  <li>
                    <router-link tag="button" to="/hygn/agency"
                      ><span>식품 위생 교육 전문 기관</span></router-link
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'hygn-index'
}
</script>

<style scoped></style>
